const firebaseConfig = {
  apiKey: "AIzaSyAxkrzcU7s6znIyz0PtFi1k9YbWQRxpvag",
  authDomain: "heath-care-website.firebaseapp.com",
  projectId: "heath-care-website",
  storageBucket: "heath-care-website.appspot.com",
  messagingSenderId: "511367849151",
  appId: "1:511367849151:web:e30033f030e0a1ac05d20a",
};
export default firebaseConfig;
